module.exports = {"applyButtonText":"Bekijk abonnementen","defaultPlaceholder":"Maak een keuze"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/product-filter.json
// module id = 4XNI
// module chunks = 1